<template>
  <div id="contenedor-eliminar-contrato-actividad">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Actividad </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la actividad? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarContratoActividad"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixDiarioActividades from './mixDiarioActividades';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarActividadContrato',
  mixins: [mixDiarioActividades],
  props: {
    contratoActividadEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      // id contrato para que no de error query de frentes de contrato del mix
      idContrato: this.contratoActividadEliminar.idContrato,
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
